import {useFocusEffect} from '@react-navigation/native';
import {useDispatch} from 'Provider';
import {useCallback, useEffect, useRef, useState} from 'react';
import {AppStateStatus} from 'react-native';
import {AppState, NativeEventSubscription} from 'react-native';

import {OffersActions} from 'store/offers/offers.reducer';

export const useGetOffers = () => {
  const dispatch = useDispatch();
  const appState = useRef(AppState.currentState);

  const handleGetOffersQuery = useCallback(() => {
    dispatch(OffersActions.getOffers({}));
  }, [dispatch]);

  const pauseOfferFetch = useCallback(() => {
    dispatch(OffersActions.pauseOffers());
  }, [dispatch]);

  const handleAppStateChange = useCallback(
    (nextAppState: AppStateStatus) => {
      if (
        appState.current.match(/inactive|background/) &&
        nextAppState === 'active'
      ) {
        // Get offers on foreground
        dispatch(OffersActions.getOffers({}));
      } else {
        // Pause offers on background
        dispatch(OffersActions.pauseOffers());
      }

      // Set the ref value regardless of screen focus.
      appState.current = nextAppState;
    },
    [dispatch]
  );

  useEffect(() => {
    const eventSub: NativeEventSubscription = AppState.addEventListener(
      'change',
      handleAppStateChange
    );
    return () => {
      eventSub?.remove();
    };
  }, [handleAppStateChange]);

  const handleFocused = useCallback(() => {
    setTimeout(() => {
      handleGetOffersQuery();
    }, 10);
    return () => {
      pauseOfferFetch();
    };
  }, [handleGetOffersQuery, pauseOfferFetch]);

  return useFocusEffect(handleFocused);
};
